import React, { useEffect, useMemo, useState } from "react";
import { getApiBase, parseJsonOrExplain, setAuthToken } from "./apiBase";

export default function SetPasswordPage({ onAuthed }) {
  const token = useMemo(() => {
    const u = new URL(window.location.href);
    return u.searchParams.get("token") || "";
  }, []);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError("Saknar token i länken.");
      setLoading(false);
      return;
    }
    fetch(`${getApiBase()}/auth/invite-info?token=${encodeURIComponent(token)}`)
      .then((r) => parseJsonOrExplain(r))
      .then((d) => setInfo(d))
      .catch((e) => setError(e.message || "Ogiltig eller utgången länk"))
      .finally(() => setLoading(false));
  }, [token]);

  const submit = (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 10) {
      setError("Lösenordet måste vara minst 10 tecken.");
      return;
    }
    if (password !== password2) {
      setError("Lösenorden matchar inte.");
      return;
    }
    setBusy(true);
    fetch(`${getApiBase()}/auth/invite-accept`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    })
      .then((r) => parseJsonOrExplain(r))
      .then((data) => {
        setAuthToken(data.token);
        onAuthed(data.user);
        window.history.replaceState({}, "", "/");
      })
      .catch((e) => setError(e.message || "Kunde inte sätta lösenord"))
      .finally(() => setBusy(false));
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f7f5f1", padding: "32px" }}>
      <div style={{ maxWidth: "420px", margin: "64px auto", background: "#fff", border: "1px solid rgba(17,17,17,0.12)", borderRadius: "18px", padding: "30px", fontFamily: "Arial, Helvetica, sans-serif" }}>
        <h1 style={{ margin: "0 0 14px 0", fontSize: "28px", fontFamily: 'Georgia, "Times New Roman", serif' }}>
          Skapa lösenord
        </h1>
        {loading && <p>Laddar...</p>}
        {!loading && info && (
          <form onSubmit={submit}>
            <p style={{ color: "#5f5a52", marginTop: 0 }}>Konto: {info.email}</p>
            <input
              type="password"
              placeholder="Nytt lösenord (minst 10 tecken)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={10}
              style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid rgba(17,17,17,0.2)", boxSizing: "border-box", marginBottom: "10px" }}
            />
            <input
              type="password"
              placeholder="Upprepa lösenord"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              required
              minLength={10}
              style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid rgba(17,17,17,0.2)", boxSizing: "border-box", marginBottom: "12px" }}
            />
            {error && <p style={{ color: "#b42318" }}>{error}</p>}
            <button
              type="submit"
              disabled={busy}
              style={{ width: "100%", padding: "12px", borderRadius: "999px", border: "none", background: "#111", color: "#fff", cursor: busy ? "wait" : "pointer" }}
            >
              {busy ? "Sparar..." : "Spara lösenord"}
            </button>
          </form>
        )}
        {!loading && !info && error && <p style={{ color: "#b42318" }}>{error}</p>}
      </div>
    </div>
  );
}
